import { hasFeature } from '~/composables/layout/access-control'
import { FEATURES } from '~/stores/layout/flags'

export default defineNuxtRouteMiddleware((to) => {
  const path = hasFeature(FEATURES.PAIES_BIS)
    ? to.path.replace(/\/paies(?=\/|$)/, '/paies-bis')
    : to.path.replace('/paies-bis', '/paies')

  if (path === to.path)
    return

  return navigateTo(
    { path, query: to.query, hash: to.hash },
    { replace: true },
  )
})
